module.exports = __webpack_public_path__ + "img/p1-c2-p1.793c5b04.jpg";